<template>
    <div>
        <div class="pl-7 pt-4">
            <div class="font-secundaria headline font-weight-bold fontColor1--text">
                NOVA UNIMED
            </div>
            <div style="line-height: 8px" class="font-secundaria subtitle-2 fontColor1--text" v-if="!$vuetify.breakpoint.xs">
                Home > Administração > Nova Unimed > <span class="font-weight-bold">{{tabName}} </span>
            </div>
        </div>
        <CardNovaUnimed @name="value => tabName = value"/>
    </div>
</template>

<script>
import CardNovaUnimed from './Shared/CardNovaUnimed'
export default {
  components: {
    CardNovaUnimed
  },
  data () {
    return {
      tabName: 'Dados Cadastrais'
    }
  },
  beforeMount () {
    this.$idUnimed = localStorage.getItem('idUnimed')
    if (this.$idUnimed === null || this.$idUnimed === undefined) {
      this.$router.push('/administracao')
    }
  }
}
</script>

<style>

</style>
